<template>
	<div class="Item">
		<headerItemDv1 msg="月申请数量趋势图"></headerItemDv1>
		<div class="grid-container">
			<div id="chart" ref="chart" style="width: 100%; height: 440px;" class="flex-1 charts-style"></div>
		</div>
	</div>
</template>
<script>
import headerItemDv1 from '../components/headerItemDv1.vue';
import * as echarts from 'echarts';

export default {
	name: '',
	components: {
		headerItemDv1
	},
	props: {
		current: Number,
	},
	watch: {
		current(newVal, oldVal) {
			if (newVal === 1) {
				this.list = this.list1
			} else if (newVal === 0) {
				this.list = this.list0
			}
			this.initChart(this.list);
		}
	},
	created() {
		this.list = this.list0
	},
	data() {
		return {
			list: {
				MAX: [],
				VALUE: []
			},
			list0: {
				MAX: [6000, 6000, 6000],
				VALUE: [2578, 897, 2077]
			},
			list1: {
				MAX: [6000, 6000, 6000],
				VALUE: [105, 641, 3118]
			},

		}
	},
	mounted() {
		this.initChart(this.list);
	},
	methods: {
		initChart(list) {
			const myChart = echarts.init(this.$refs.chart);
			const CubeLeft = echarts.graphic.extendShape({
				shape: {
					x: 0,
					y: 0
				},
				buildPath: function (ctx, shape) {
					const xAxisPoint = shape.xAxisPoint
					const c0 = [shape.x, shape.y]
					const c1 = [shape.x - 9, shape.y - 9]
					const c2 = [xAxisPoint[0] - 9, xAxisPoint[1] - 9]
					const c3 = [xAxisPoint[0], xAxisPoint[1]]
					ctx.moveTo(c0[0], c0[1]).lineTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).closePath()
				}
			})
			const CubeRight = echarts.graphic.extendShape({
				shape: {
					x: 0,
					y: 0
				},
				buildPath: function (ctx, shape) {
					const xAxisPoint = shape.xAxisPoint
					const c1 = [shape.x, shape.y]
					const c2 = [xAxisPoint[0], xAxisPoint[1]]
					const c3 = [xAxisPoint[0] + 18, xAxisPoint[1] - 9]
					const c4 = [shape.x + 18, shape.y - 9]
					ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath()
				}
			})
			const CubeTop = echarts.graphic.extendShape({
				shape: {
					x: 0,
					y: 0
				},
				buildPath: function (ctx, shape) {
					const c1 = [shape.x, shape.y]
					const c2 = [shape.x + 18, shape.y - 9]
					const c3 = [shape.x + 9, shape.y - 18]
					const c4 = [shape.x - 9, shape.y - 9]
					ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath()
				}
			})
			echarts.graphic.registerShape('CubeLeft', CubeLeft)
			echarts.graphic.registerShape('CubeRight', CubeRight)
			echarts.graphic.registerShape('CubeTop', CubeTop)
			const MAX = list.MAX
			const VALUE = list.VALUE
			const option = {
				title: {
					text: '',
					top: 32,
					left: 18,
					textStyle: {
						color: '#00F6FF',
						fontSize: 24
					}
				},
				grid: {
					left: 20,
					right: 40,
					bottom: '19%',
					top: 107,
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: ['一月', '二月', '三月'],
					axisLine: {
						show: true,
						lineStyle: {
							color: 'white'
						}
					},
					offset: 20,
					axisTick: {
						show: false,
						length: 9,
						alignWithLabel: true,
						lineStyle: {
							color: '#7DFFFD'
						}
					},
					axisLabel: {
						fontSize: 10
					}
				},
				yAxis: {
					type: 'value',
					axisLine: {
						show: true,
						lineStyle: {
							color: 'white'
						}
					},
					splitLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						fontSize: 16
					},
					boundaryGap: ['20%', '20%']
				},
				series: [{
					type: 'custom',
					renderItem: function (params, api) {
						const location = api.coord([api.value(0), api.value(1)])
						return {
							type: 'group',
							children: [{
								type: 'CubeLeft',
								shape: {
									api,
									xValue: api.value(0),
									yValue: api.value(1),
									x: location[0],
									y: location[1],
									xAxisPoint: api.coord([api.value(0), 0])
								},
								style: {
									fill: 'rgba(47,102,192,.27)'
								}
							}, {
								type: 'CubeRight',
								shape: {
									api,
									xValue: api.value(0),
									yValue: api.value(1),
									x: location[0],
									y: location[1],
									xAxisPoint: api.coord([api.value(0), 0])
								},
								style: {
									fill: 'rgba(59,128,226,.27)'
								}
							}, {
								type: 'CubeTop',
								shape: {
									api,
									xValue: api.value(0),
									yValue: api.value(1),
									x: location[0],
									y: location[1],
									xAxisPoint: api.coord([api.value(0), 0])
								},
								style: {
									fill: 'rgba(72,156,221,.27)'
								}
							}]
						}
					},
					data: MAX
				}, {
					type: 'custom',
					renderItem: (params, api) => {
						const location = api.coord([api.value(0), api.value(1)])
						return {
							type: 'group',
							children: [{
								type: 'CubeLeft',
								shape: {
									api,
									xValue: api.value(0),
									yValue: api.value(1),
									x: location[0],
									y: location[1],
									xAxisPoint: api.coord([api.value(0), 0])
								},
								style: {
									fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#3B80E2'
									},
									{
										offset: 1,
										color: '#49BEE5'
									}
									])
								}
							}, {
								type: 'CubeRight',
								shape: {
									api,
									xValue: api.value(0),
									yValue: api.value(1),
									x: location[0],
									y: location[1],
									xAxisPoint: api.coord([api.value(0), 0])
								},
								style: {
									fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#3B80E2'
									},
									{
										offset: 1,
										color: '#49BEE5'
									}
									])
								}
							}, {
								type: 'CubeTop',
								shape: {
									api,
									xValue: api.value(0),
									yValue: api.value(1),
									x: location[0],
									y: location[1],
									xAxisPoint: api.coord([api.value(0), 0])
								},
								style: {
									fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
										offset: 0,
										color: '#3B80E2'
									},
									{
										offset: 1,
										color: '#49BEE5'
									}
									])
								}
							}]
						}
					},
					data: VALUE
				}, {
					type: 'bar',
					label: {
						normal: {
							show: true,
							position: 'top',
							formatter: (e) => {
								switch (e.name) {
									case '10kV线路':
										return VALUE[0]
									case '公用配变':
										return VALUE[1]
									case '35kV主变':
										return VALUE[2]
									case '水':

								}
							},
							fontSize: 16,
							color: '#fff',
							offset: [4, -25]
						}
					},
					itemStyle: {
						color: 'transparent'
					},
					data: MAX
				}]
			}
			myChart.setOption(option);
			window.onresize = function () {
				myChart.resize();
			}
		}
	}
}
</script>
<style lang="less" scoped>
.Item {
	font-size: 10px !important;

	.grid-container {
		width: 100%;
		display: grid;
		grid-template-columns: 1fr;
		/* 这表示列的大小为1fr */
		grid-template-rows: 1fr;
		/* 这表示行的大小为1fr */
		justify-items: center;

		.grid-item {
			box-sizing: border-box;
			border: 1px solid #e4e4e4;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			text-align: center;
			padding: 20px;
		}

		.custom-font /deep/ .board-item {
			font-size: 10px;
		}
	}
}
</style>
